import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "add-to-language-group-modal" */'./AddToLanguageGroupModal').then(mod => mod.default),
  LoadingComponent: () => null
});